// // PermissionPagination.jsx
// import React from "react";

// const Pagination = ({ totalRecords, currentPage, pageSize, onPageChange, onPageSizeChange }) => {
//   const totalPages = Math.ceil(totalRecords / pageSize);
//   return (
//     <div className="mt-4 flex items-center justify-between text-sm">
//       <span>{(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, totalRecords)} / {totalRecords} kết quả</span>
//       <div className="flex items-center gap-1">
//         <button
//           className="px-2 py-1 border rounded"
//           disabled={currentPage === 1}
//           onClick={() => onPageChange(currentPage - 1)}
//         >&lt;</button>
//         {[...Array(totalPages)].map((_, i) => (
//           <button
//             key={i}
//             className={`px-2 py-1 border rounded ${currentPage === i + 1 ? 'bg-gray-300' : ''}`}
//             onClick={() => onPageChange(i + 1)}
//           >{i + 1}</button>
//         ))}
//         <button
//           className="px-2 py-1 border rounded"
//           disabled={currentPage === totalPages}
//           onClick={() => onPageChange(currentPage + 1)}
//         >&gt;</button>
//         <select
//           className="ml-2 px-2 py-1 border rounded"
//           value={pageSize}
//           onChange={(e) => onPageSizeChange(Number(e.target.value))}
//         >
//           {[10, 20, 50].map(size => <option key={size} value={size}>{size} / trang</option>)}
//         </select>
//       </div>
//     </div>
//   );
// };

// export default Pagination;


// =============================
// File: PermissionPagination.jsx
// =============================
import React from "react";

const Pagination = ({ totalRecords, currentPage, pageSize, onPageChange, onPageSizeChange }) => {
  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize || 1));
  const from = totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const to = Math.min(currentPage * pageSize, totalRecords);

  return (
    <div className="mt-4 flex items-center justify-between text-sm">
      <span>
        {from}-{to} / {totalRecords} kết quả
      </span>
      <div className="flex items-center gap-1">
        <button
          className="px-2 py-1 border rounded"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          &lt;
        </button>
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`px-2 py-1 border rounded ${currentPage === i + 1 ? "bg-gray-300" : ""}`}
            onClick={() => onPageChange(i + 1)}
          >
            {i + 1}
          </button>
        ))}
        <button
          className="px-2 py-1 border rounded"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          &gt;
        </button>
        <select
          className="ml-2 px-2 py-1 border rounded"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {[10, 20, 50].map((size) => (
            <option key={size} value={size}>
              {size} / trang
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Pagination;